// extracted by mini-css-extract-plugin
export default {"container":"subcategory_container__HwSuv","removeThisClass":"subcategory_removeThisClass__tYJ8E"};